module.exports = __webpack_public_path__ + "img/icon-room-bedroom.bbb606f9.svg";